import { FAQsContainer, Accordion, Action, SectionTitle } from './styles';
import Expandable from './Expandables';

const Index = ({
  title = 'Get more answers',
  showBackground = false,
  addPadding = false,
  addMax = false,
  width = '',
  seeMore = null,
  helpData,
  titleAlignment = 'left',
  styles = {},
}: any) => {
  return (
    <FAQsContainer
      width={width}
      addMax={addMax}
      showBackground={showBackground}
      addPadding={addPadding}
    >
      <SectionTitle align={titleAlignment} marginTop={'30px'}>
        {title}
      </SectionTitle>
      <Accordion>
        {!!helpData &&
          helpData?.map((item: any, i) => {
            return (
              <Expandable
                key={i}
                item={item}
                accordionItemStyles={styles?.accordionItemStyles}
              />
            );
          })}
      </Accordion>
      {seeMore && <Action onClick={seeMore}>{`See more`}</Action>}
    </FAQsContainer>
  );
};

export default Index;
